<template>
  <v-snackbar
    v-model="snackbar"
    color="white"
    variant="elevated"
    :timeout="-1"
    :location="'right'"
    :style="`bottom: ${index * 65 + 25 * pastNotificationInfoLength}px;`"
    max-width="100%"
  >
    <div class="d-flex" style="font-size: 16px">
      <v-icon color="red" class="pe-2"> mdi-alert-octagon </v-icon>
      <span class="font-weight-bold me-2" style="color: black"
        >Error <span v-if="status">{{ status }}</span
        >:</span
      >
      <span class="font-weight-medium" style="color: black">{{ text }}</span>
    </div>
    <template #actions>
      <v-btn color="red" variant="text" @click="closeToast"> Cerrar </v-btn>
    </template>
    <div v-if="hasInfo">
      <div class="ms-8" v-for="information in info" :key="information">
        <span style="font-size: 15px; color: black">{{ information }}</span>
      </div>
    </div>
  </v-snackbar>
</template>

<script>
import { ref } from "vue";

export default {
  name: "Error",
  props: {
    text: String,
    id: Number,
    index: Number,
    status: Number,
    info: Array,
    hasInfo: Boolean,
    pastNotificationInfoLength: Number,
  },
  emits: ["closeToast"],
  setup(props, { emit }) {
    const snackbar = ref(true);

    const closeToast = () => {
      snackbar.value = false;
      emit("closeToast", props.id);
    };

    return {
      snackbar,
      closeToast,
    };
  },
};
</script>

<style></style>
